/* Personalizer v3 step flow + state machine (vanilla, no jQuery).
   State shape: { besties: [{ type, color }...], upsells: [variantId...],
   note: '' } plus a single photo-group handle (personalizer-upload.js).
   Rendering helpers live in personalizer-render.js / -render-steps.js;
   pricing/payload/submit in personalizer-cart.js.
   The step registry below is the ONLY source of truth for both navigation and
   the segmented stepper — never derive step counts anywhere else. */
(function () {
  'use strict';

  var root = document.querySelector('[data-personalizer]');
  var configEl = root && root.querySelector('[data-personalizer-config]');
  if (!root || !configEl || !window.PersonalizerUpload || !window.PersonalizerCart ||
      !window.PersonalizerRender || !window.PersonalizerRender.renderTypeRows) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (err) {
    return; // malformed embed — leave static markup as-is
  }
  if (!config.variants || !config.variants.length || !config.types || !config.types.length) return;

  // v4 key: older saves were built against the per-bestie COLOR-variant
  // product — the variant map changed to combo "Set" SKUs, so ignore them.
  var storageKey = 'personalizer:v4:' + root.getAttribute('data-product-id');
  var typeKeys = config.types.map(function (t) { return t.key; });
  var defaultType = typeKeys.indexOf(config.defaultType) !== -1 ? config.defaultType : typeKeys[0];
  // Unit ceiling: bags carry up to 3, nursery mobiles up to 6-7 (config.maxUnits).
  var maxUnits = parseInt(config.maxUnits, 10) || 3;
  // orderType is oneBag-only: what the ORDER buys (full | tote | charm) —
  // full = tote + n dolls, tote = tote + embroidery alone, charm = dolls only.
  // twin: the post-extras "same set again, 2nd 30% off" offer (X2 variants).
  // upsellPets: per-pet upsell selections keyed by product handle (wings).
  /* countChosen: whether the count on screen is the customer's pick or just
     the working default the rest of the flow needs to price itself. Bag
     products start unchosen — no card lit, no preview, no way off the count
     page until one is tapped. Every other product is chosen from the start,
     since its default count is the offer. */
  // orderType starts at the config's default type, not a hard-coded 'full':
  // the charm-only product opens as a charm order (no bag colour step, no bag
  // in the preview) instead of impersonating a Full Set.
  var state = { besties: [], countChosen: false, upsells: [], note: '', orderName: '', orderType: defaultType, twin: false, upsellPets: {}, upsellNotes: {}, upsellNameCharm: { items: [] }, upsellPhotos: {}, axis: null, sameSubject: null };
  // Products whose second option deserves its own page (countAxis.ownStep —
  // the memorial dolls' size) open on it; everything else keeps its old flow.
  var axisOwnStep = config.bagMode === 'count' && !!(config.countAxis && config.countAxis.ownStep);
  // Products whose card details (per-doll name + dates) get their own page
  // after the photos (config.cardStep): the names mount authored inside the
  // photos panel moves into that page — moving the node keeps renderNames
  // wired onto it. Without the panel the fields simply stay on the photos page.
  var cardOwnStep = !!(config.cardStep && config.nameField && !config.nameField.single);
  if (cardOwnStep) {
    var cardPanel = root.querySelector('[data-personalizer-card-panel]');
    var namesMount = root.querySelector('[data-personalizer-names]');
    if (cardPanel && namesMount) cardPanel.appendChild(namesMount); else cardOwnStep = false;
  }
  // A one-type bag product (the charm-only page) has nothing to decide on the
  // "What would you like?" page, so that page does not exist for it.
  var oneBagSingleType = config.bagMode === 'oneBag' && typeKeys.length < 2;
  var currentStep = config.bagMode === 'oneBag'
    ? (oneBagSingleType ? 'besties' : 'type')
    : (axisOwnStep ? 'size' : 'besties');
  var photoGroup = null;
  // Interstitial "twin offer" panel: NOT a stepper step — entered by the
  // extras step's Add-to-cart click, left via Back / any tab.
  var onTwinStep = false;
  // nameField.single products embroider ONE line for the whole piece;
  // it lives on the order, not on a unit.
  var singleName = !!(config.nameField && config.nameField.single);
  var onCrossStep = false;
  // Second interstitial for bag products: another design from the collection,
  // built from everything they already told us (config.bagDesigns).
  var onDesignStep = false;
  /* Step names the user has actually landed on. Forward jumps are allowed one
     step past the furthest visited (and never past the first invalid step), so
     vacuously-valid steps (photos with no upload endpoint, extras) can't be
     skipped to from step 1. Keyed by name, not index, because the registry can
     shrink (colours step drops out). Never persisted. */
  var visitedSteps = {};

  var ctx = {
    root: root,
    // read-only handle for display-only overlays (sale mode) — nothing
    // outside this file mutates state through it
    state: state,
    config: config,
    storageKey: storageKey,
    photoGroup: function () { return photoGroup; },
    // true while every doll gets its own upload row (different people)
    photoSplit: function () { return photoSplit(); },
    stepValid: stepValid, // renderTabs derives the ✓/done segments from this
    /* Display gate for the sticky-bar totals: extras/upsell prices join the
       shown total only once the Extras step (registry name 'review') has been
       reached. 'review' is always last in the registry, so a visited flag is
       equivalent to "furthest step reached >= extras index". Never gates the
       cart payload — buildItems reads the checkboxes directly. */
    extrasReached: function () { return !!visitedSteps.review; },
    onStateChange: function () { saveState(); refreshUI(); },
    /* Text-input path: persist + re-derive ONLY the nav buttons' disabled
       state. Never calls refreshUI — a rebuild would destroy the focused
       input mid-typing (same reason the notes textarea skips it). */
    onFieldInput: function () { saveState(); updateNavDisabled(); },
    /* oneBag: order-level type card clicked (render-steps). Re-derives unit
       types/colours, step registry (colours drops for charm) and prices. */
    setOrderType: function (key) {
      state.orderType = key;
      enforceOneBagTypes();
      window.PersonalizerRender.renderOrderType(ctx);
      window.PersonalizerRender.renderCounts(ctx);
      window.PersonalizerRender.renderColorRows(ctx);
      window.PersonalizerRender.renderNames(ctx);
      ctx.onStateChange();
    },
    /* Second product option (count mode), e.g. the nursery-mobile frame. */
    setAxis: function (name) {
      state.axis = name;
      window.PersonalizerRender.renderAxis(ctx);
      window.PersonalizerRender.renderCounts(ctx);
      ctx.onStateChange();
    },
    setTwin: function (on) {
      state.twin = !!on;
      ctx.onStateChange();
    },
    /* Multi-doll count orders: "the same person" (true) or "different
       people" (false) — re-draws the preview, the question and the card
       name rows (one shared row when they are the same). */
    setSameSubject: function (v) {
      state.sameSubject = !!v;
      window.PersonalizerRender.renderSameSubject(ctx);
      window.PersonalizerRender.renderBagPreview(ctx);
      window.PersonalizerRender.renderNames(ctx);
      ctx.onStateChange();
    },
    setCount: setBestiesCount,
    /* Tab-click routing: completed steps are always revisitable; forward
       jumps only up to the reachable cap (same rule renderTabs disables by). */
    goToStep: function (name) {
      var steps = activeSteps();
      var target = steps.indexOf(name);
      if (target === -1 || (name === currentStep && !onTwinStep)) return;
      if (target > reachableMax(steps)) return;
      onTwinStep = false; // any tab click leaves an interstitial
      onCrossStep = false;
      onDesignStep = false;
      currentStep = name;
      refreshUI();
    }
  };
  window.__personalizerCtx = ctx;

  function typeNeedsColor(key) {
    var def = window.PersonalizerCart.typeDef(config, key);
    return !!(def && def.needsColor);
  }

  /* Colours step stays in the registry while any bestie needs a colour and
     drops out only when every bestie picked a colourless type. oneBag: there
     is a bag (and its colour) unless the order is dolls-only. */
  function activeSteps() {
    // Bag products decide one thing per page: what they are buying, then the
    // bag's colour, then how many pets go on it. Dolls-only orders have no bag
    // to colour, so that page drops out of the flow.
    if (config.bagMode === 'oneBag') {
      var bagSteps = oneBagSingleType ? [] : ['type'];
      if (state.orderType !== 'charm') bagSteps.push('colors');
      return bagSteps.concat(['besties', 'photos', 'review']);
    }
    var needsColors = state.besties.length === 0 || state.besties.some(function (b) {
      return !b.type || typeNeedsColor(b.type);
    });
    var steps = axisOwnStep ? ['size', 'besties'] : ['besties'];
    if (needsColors) steps.push('colors');
    steps.push('photos');
    if (cardOwnStep) steps.push('card');
    return steps.concat(['review']);
  }

  /* --- persistence (File objects excluded; uploaded URLs kept) --- */
  function saveState() {
    try {
      syncUpsellsFromDom();
      sessionStorage.setItem(storageKey, JSON.stringify({
        besties: state.besties,
        countChosen: state.countChosen,
        // Where they were, not just what they entered. Coming back to page one
        // of five reads as "nothing was saved" even when everything was — the
        // work is simply two steps further in.
        currentStep: currentStep,
        photos: photoGroup ? photoGroup.getPhotos() : [],
        // how many of those photos belong to each doll (different people only)
        photoUnits: photoGroup && photoGroup.getPhotosByUnit
          ? (photoGroup.getPhotosByUnit() || []).map(function (arr) { return arr.length; })
          : [],
        upsells: state.upsells,
        note: state.note,
        orderType: state.orderType,
        axis: state.axis,
        sameSubject: state.sameSubject,
        twin: state.twin,
        upsellPets: state.upsellPets,
        upsellNotes: state.upsellNotes,
        upsellNameCharm: state.upsellNameCharm,
        upsellPhotos: state.upsellPhotos,
        orderName: state.orderName
      }));
    } catch (err) { /* storage full/blocked — flow works without persistence */ }
  }

  function stepValid(name) {
    var oneBag = config.bagMode === 'oneBag';
    // The type page carries its own default (the Full Set), so it is valid
    // from first paint — it exists to be read, not to be unblocked.
    if (name === 'type') return !!state.orderType;
    // Same for the size page: a default size is always selected.
    if (name === 'size') return !!state.axis;
    if (name === 'besties') {
      if (!state.countChosen) return false;
      // two or more dolls: whether they are of the same person is answered, never assumed
      if (config.sameSubject && state.besties.length >= 2 && typeof state.sameSubject !== 'boolean') return false;
      return state.besties.length > 0 && state.besties.every(function (b) { return !!b.type; });
    }
    if (name === 'colors') {
      // oneBag: the single bag colour lives on unit 0.
      if (oneBag) return !!(state.besties[0] && state.besties[0].color);
      return state.besties.every(function (b) { return !b.type || !typeNeedsColor(b.type) || !!b.color; });
    }
    if (name === 'photos') {
      // tote-only orders have nothing to crochet — photos become optional.
      var photosRequired = !(oneBag && state.orderType === 'tote');
      if (photosRequired && !(photoGroup && photoGroup.isValid())) return false;
      // the name fields validate on their own page when they have one
      return cardOwnStep ? true : namesValid();
    }
    if (name === 'card') return namesValid();
    if (name === 'review') {
      // A ticked per-pet add-on (wings & halo) must say WHICH pets before the
      // order can be placed — no silent defaults. Note-style add-ons need
      // their "which pet" text for the same reason.
      var ok = true;
      // A ticked per-pet add-on must say WHICH pets from two pets up (one
      // pet: it can only be for them). Note-style add-ons need their "which
      // pet" text; a photo-pick add-on needs at least one photo; the name
      // charm needs a colour and a name on every charm.
      var petCount = state.besties.length;
      root.querySelectorAll('.personalizer__upsell-input:checked[data-per-pet]').forEach(function (input) {
        if (petCount <= 1) return;
        var h = input.getAttribute('data-handle') || '';
        var sel = (state.upsellPets[h] || []).filter(function (i) { return i >= 0 && i < petCount; });
        if (!sel.length) ok = false;
      });
      // the note field only exists from two pets up (renderUpsellNotes) — with
      // one pet the tick is the whole answer, so nothing to require
      root.querySelectorAll('.personalizer__upsell-input:checked[data-note-upsell]').forEach(function (input) {
        if (petCount <= 1) return;
        var h = input.getAttribute('data-handle') || '';
        if (!String(state.upsellNotes[h] || '').trim()) ok = false;
      });
      var photoCount = photoGroup ? photoGroup.getPhotos().length : 0;
      root.querySelectorAll('.personalizer__upsell-input:checked[data-photo-pick]').forEach(function (input) {
        var h = input.getAttribute('data-handle') || '';
        var sel = ((state.upsellPhotos || {})[h] || []).filter(function (i) { return i >= 0 && i < photoCount; });
        if (!sel.length) ok = false;
      });
      root.querySelectorAll('.personalizer__upsell-input:checked[data-name-charm]').forEach(function () {
        var items = (state.upsellNameCharm && state.upsellNameCharm.items) || [];
        if (!items.length) ok = false;
        items.forEach(function (it) { if (!it.colour || !String(it.name || '').trim()) ok = false; });
      });
      return ok;
    }
    return true;
  }

  /* Embroidered-name products: every unit needs its name (and a required
     extra field) before moving on — dolls-only bag orders have no bag, hence
     nothing to embroider. */
  function namesValid() {
    var oneBag = config.bagMode === 'oneBag';
    if (config.nameField && config.nameField.required && !(oneBag && state.orderType === 'charm')) {
      if (singleName) {
        if (!String(state.orderName || '').trim()) return false;
      } else if (!state.besties.every(function (b) { return !!String(b.petName || '').trim(); })) {
        return false;
      }
    }
    if (config.extraField && config.extraField.required && !(oneBag && state.orderType === 'charm')) {
      return state.besties.every(function (b) { return !!String(b.petExtra || '').trim(); });
    }
    return true;
  }

  function firstInvalidIdx(steps) {
    for (var i = 0; i < steps.length; i++) {
      if (!stepValid(steps[i])) return i;
    }
    return steps.length;
  }

  /* Furthest clickable segment: first invalid step caps forward jumps, and
     validity alone never opens steps more than one past the furthest visited. */
  function reachableMax(steps) {
    var idx = steps.indexOf(currentStep);
    var maxReachedIdx = 0;
    steps.forEach(function (s, i) { if (visitedSteps[s]) maxReachedIdx = Math.max(maxReachedIdx, i); });
    return Math.min(
      Math.min(firstInvalidIdx(steps), steps.length - 1),
      Math.max(maxReachedIdx + 1, idx)
    );
  }

  /* Nav enablement alone (Next/Add-to-cart) — shared by refreshUI and the
     light text-input path (ctx.onFieldInput). */
  function updateNavDisabled() {
    var steps = activeSteps();
    root.querySelector('[data-personalizer-next]').disabled = !stepValid(currentStep);
    root.querySelector('[data-personalizer-submit]').disabled = !steps.every(stepValid);
  }

  /* After a step change the card's top goes back under the (sticky) header,
     so the new panel starts where the eye is — only when the top has left
     the viewport; desktop, where the whole card fits, never jumps. */
  function scrollToStepTop() {
    var top = root.getBoundingClientRect().top;
    if (top >= 0 && top <= 140) return;
    var hdr = document.querySelector('.site-header');
    var pos = hdr ? getComputedStyle(hdr).position : '';
    var off = (hdr && (pos === 'sticky' || pos === 'fixed')) ? hdr.getBoundingClientRect().height + 8 : 12;
    var y = Math.max(0, top + window.pageYOffset - off);
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }

  function refreshUI() {
    var steps = activeSteps();
    // A type change can remove the colours step from under the user — land on photos.
    if (steps.indexOf(currentStep) === -1) currentStep = 'photos';
    var idx = steps.indexOf(currentStep);
    visitedSteps[currentStep] = true;
    var isLast = idx === steps.length - 1;
    var activeBefore = document.activeElement;

    var onAside = onTwinStep || onDesignStep || onCrossStep;
    var shownStep = onTwinStep ? 'twin'
      : (onDesignStep ? 'designs' : (onCrossStep ? 'cross' : currentStep));
    root.querySelectorAll('[data-personalizer-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-personalizer-step') !== shownStep;
    });
    // visibility (not hidden): the bar keeps its layout on step 1.
    root.querySelector('[data-personalizer-back]').style.visibility =
      (idx === 0 && !onAside) ? 'hidden' : 'visible';
    var nextBtn = root.querySelector('[data-personalizer-next]');
    nextBtn.hidden = isLast || onAside;
    nextBtn.disabled = !stepValid(currentStep);
    var submitBtn = root.querySelector('[data-personalizer-submit]');
    submitBtn.hidden = !(isLast || onAside);
    submitBtn.disabled = !steps.every(stepValid);

    window.PersonalizerRender.renderTabs(ctx, steps, idx, reachableMax(steps));
    window.PersonalizerRender.updateBar(ctx);
    if (window.PersonalizerRender.renderTwin) window.PersonalizerRender.renderTwin(ctx);
    if (onDesignStep && window.PersonalizerBagDesigns) window.PersonalizerBagDesigns.render(ctx);
    if (onCrossStep && window.PersonalizerCross) window.PersonalizerCross.render(ctx);
    if (window.PersonalizerRender.renderUpsellPets) window.PersonalizerRender.renderUpsellPets(ctx);
    if (window.PersonalizerRender.renderUpsellNotes) window.PersonalizerRender.renderUpsellNotes(ctx);
    if (window.PersonalizerRender.renderUpsellNameCharm) window.PersonalizerRender.renderUpsellNameCharm(ctx);
    if (window.PersonalizerRender.renderUpsellPhotoPick) window.PersonalizerRender.renderUpsellPhotoPick(ctx);
    if (window.PersonalizerRender.renderPhotoUnits) window.PersonalizerRender.renderPhotoUnits(ctx);
    if (window.PersonalizerRender.renderCardPreview) window.PersonalizerRender.renderCardPreview(ctx);

    // Hiding the focused Next/Back button — or destroying the focused element
    // outright (renderTabs rebuilds the stepper with innerHTML='') — drops
    // keyboard focus to <body> and tabbing restarts from the page top. A
    // removed node keeps hidden=false, so also check it is still in the
    // document. Move focus deliberately: a destroyed segment goes to its
    // freshly rendered replacement (the now-active one); everything else to
    // the submit button or the current step panel.
    var detached = activeBefore && !document.documentElement.contains(activeBefore);
    if (activeBefore && (activeBefore.hidden || detached)) {
      var wasTab = detached && activeBefore.classList && activeBefore.classList.contains('personalizer__stp');
      var focusTarget = wasTab
        ? root.querySelector('#personalizer-tab-' + currentStep)
        : (isLast && !submitBtn.disabled
          ? submitBtn
          : root.querySelector('[data-personalizer-step="' + currentStep + '"]'));
      if (focusTarget) {
        if (focusTarget !== submitBtn && !wasTab) focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus();
      }
    }
  }

  /* oneBag mode invariant: ONE tote carries every unit — unit 0 is the "full"
     (bag + doll, holds the bag colour), every other unit is an extra "charm"
     doll on the same bag (no colour of its own). Applied after count changes
     AND after session restore, so stale saves can't smuggle other shapes. */
  function enforceOneBagTypes() {
    if (config.bagMode !== 'oneBag') return;
    if (typeKeys.indexOf(state.orderType) === -1) state.orderType = 'full';
    var ot = state.orderType;
    state.besties.forEach(function (b, i) {
      if (ot === 'full') b.type = i === 0 ? 'full' : 'charm';
      else b.type = ot; // tote / charm orders: every unit mirrors the order type
      if (i > 0 || ot === 'charm') b.color = null; // colour = the ONE bag, unit 0 only
    });
  }

  /* Count change keeps existing picks; NEW besties default to the Full Set
     (config.defaultType) — both initially and when the count increases. */
  function setBestiesCount(n) {
    var prev = state.besties;
    state.besties = [];
    for (var i = 0; i < n; i++) state.besties.push(prev[i] || { type: defaultType, color: null, petName: '' });
    state.countChosen = true; // only ever reached by a tap on a count card
    enforceOneBagTypes();
    window.PersonalizerRender.renderCounts(ctx);
    window.PersonalizerRender.renderTypeRows(ctx);
    window.PersonalizerRender.renderColorRows(ctx);
    window.PersonalizerRender.renderNames(ctx);
    ctx.onStateChange();
  }

  function syncUpsellsFromDom() {
    state.upsells = Array.prototype.map.call(
      root.querySelectorAll('.personalizer__upsell-input:checked'),
      function (el) { return el.value; }
    );
  }

  /* Selected styling fallback for browsers without :has(): mirror each
     checkbox's checked state onto its row as a class (rules duplicated in
     personalizer-steps.css under .personalizer__up--selected). */
  function syncUpsellRowClasses() {
    root.querySelectorAll('.personalizer__upsell-input').forEach(function (input) {
      var row = input.closest('.personalizer__up');
      if (row) row.classList.toggle('personalizer__up--selected', input.checked);
    });
  }

  /* --- wire events --- */
  /* A photo-pick add-on starts with the first order photo picked, so one tap
     is enough — seeded HERE (before the state change is validated/saved), not
     in the renderer, or the sticky button would stay disabled until the next
     refresh. */
  function seedPhotoPickDefault(input) {
    if (!input.checked || !input.hasAttribute('data-photo-pick')) return;
    var h = input.getAttribute('data-handle') || '';
    if (!state.upsellPhotos) state.upsellPhotos = {};
    if (state.upsellPhotos[h] === undefined && photoGroup && photoGroup.getPhotos().length) state.upsellPhotos[h] = [0];
  }
  root.querySelectorAll('.personalizer__upsell-input').forEach(function (input) {
    input.addEventListener('change', function () {
      syncUpsellsFromDom();
      syncUpsellRowClasses();
      seedPhotoPickDefault(input);
      ctx.onStateChange();
    });
  });

  // Twin-offer checkbox: delegated (the panel's DOM is rebuilt on every
  // refreshUI, so a listener on the input itself would be replaced away).
  root.addEventListener('change', function (ev) {
    if (ev.target && ev.target.classList && ev.target.classList.contains('personalizer__twin-input')) {
      ctx.setTwin(ev.target.checked);
    }
  });

  var notesEl = root.querySelector('[data-personalizer-notes]');
  if (notesEl) {
    notesEl.addEventListener('input', function () {
      state.note = notesEl.value;
      saveState(); // no refreshUI — typing must not rebuild anything
    });
  }

  root.querySelector('[data-personalizer-back]').addEventListener('click', function () {
    if (onCrossStep) { onCrossStep = false; refreshUI(); scrollToStepTop(); return; } // back to extras
    if (onDesignStep) { onDesignStep = false; refreshUI(); scrollToStepTop(); return; } // back to extras
    if (onTwinStep) { onTwinStep = false; refreshUI(); scrollToStepTop(); return; } // back to extras
    var steps = activeSteps();
    var idx = steps.indexOf(currentStep);
    if (idx > 0) { currentStep = steps[idx - 1]; refreshUI(); scrollToStepTop(); }
  });
  root.querySelector('[data-personalizer-next]').addEventListener('click', function () {
    var steps = activeSteps();
    var idx = steps.indexOf(currentStep);
    if (stepValid(currentStep) && idx < steps.length - 1) { currentStep = steps[idx + 1]; refreshUI(); scrollToStepTop(); }
  });
  function trySubmit() {
    if (!activeSteps().every(stepValid)) return;
    // First Add-to-cart click (extras step) routes through the twin offer
    // when configured; the click on the twin panel itself really submits.
    // The twin card is retired wherever the design offer is configured — not
    // merely where this particular order qualifies for it, or every order the
    // design offer skips would fall back to the card it replaced. Both keys
    // can sit on the product at once: the live theme, which knows nothing of
    // bagDesigns, keeps showing its twin offer until this ships.
    var designs = window.PersonalizerBagDesigns;
    var hasDesigns = !!(designs && designs.hasOffer());
    if (!onTwinStep && !config.bagDesigns && config.twinOffer && config.bagMode === 'oneBag') {
      onTwinStep = true;
      refreshUI();
      scrollToStepTop();
      return;
    }
    // Then the other bag designs, on the products that have siblings to offer.
    if (!onDesignStep && hasDesigns) {
      onDesignStep = true;
      refreshUI();
      scrollToStepTop();
      return;
    }
    // A design picked but left colourless blocks the order — shipping a bag in
    // a colour nobody chose is worse than one more tap.
    if (designs && designs.accepted() && !designs.isValid()) {
      var designErr = root.querySelector('[data-personalizer-form-error]');
      if (designErr) {
        designErr.textContent = designs.missing();
        designErr.hidden = false;
      }
      return;
    }
    // Then the companion-product offer, on the products that carry one.
    var cross = window.PersonalizerCross;
    if (!onCrossStep && cross && cross.hasOffer()) {
      onCrossStep = true;
      refreshUI();
      scrollToStepTop();
      return;
    }
    // An accepted offer with a required field still blank blocks the order:
    // shipping a sweater with no name on it is worse than one more tap.
    if (cross && cross.accepted() && !cross.isValid()) {
      cross.showError(cross.missing());
      return;
    }
    window.PersonalizerCart.submitToCart(ctx);
  }

  root.querySelector('[data-personalizer-submit]').addEventListener('click', trySubmit);
  // "No thanks" inside the offer card declines and places the order in one tap.
  root.addEventListener('personalizer:submit', trySubmit);

  window.PersonalizerRender.initStaticContent(ctx);
  if (window.PersonalizerBagDesigns) window.PersonalizerBagDesigns.init(ctx);
  if (window.PersonalizerCross) window.PersonalizerCross.init(ctx);

  /* --- restore previous session (guarded: stale types/colours dropped) --- */
  var savedPhotos = [];
  var savedPhotosRaw = [];   // unfiltered, so per-doll counts still line up
  var savedPhotoUnits = null; // photos per doll at save time (different people)
  var savedStep = null;
  try {
    var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved) {
      var paletteNames = (config.palettes || []).map(function (p) { return p.name; });
      state.besties = (saved.besties || []).slice(0, maxUnits).map(function (b) {
        var type = b && typeKeys.indexOf(b.type) !== -1 ? b.type : defaultType;
        var color = b && paletteNames.indexOf(b.color) !== -1 ? b.color : null;
        if (!typeNeedsColor(type)) color = null; // colourless types carry no ghost colour
        var petName = b && typeof b.petName === 'string' ? b.petName.slice(0, 40) : '';
        var petExtra = b && typeof b.petExtra === 'string' ? b.petExtra.slice(0, 12) : '';
        return { type: type, color: color, petName: petName, petExtra: petExtra };
      });
      // Restored URLs must pass the SAME rule the upload path enforces
      // (https + .jpg/.jpeg/.png/.webp pathname — personalizer-upload.js
      // isValidUploadedUrl). sessionStorage is user-writable, so invalid
      // entries are silently dropped instead of trusted.
      savedPhotosRaw = Array.isArray(saved.photos) ? saved.photos : [];
      savedPhotos = savedPhotosRaw.filter(function (p) {
        return p && p.url && window.PersonalizerUpload.isValidUploadedUrl(p.url);
      });
      if (Array.isArray(saved.photoUnits) && saved.photoUnits.length) {
        savedPhotoUnits = saved.photoUnits.map(function (c) { return Math.max(0, parseInt(c, 10) || 0); });
      }
      // A saved visit overrides the Liquid-checked default (incl. an unticked
      // recommended upsell): clear everything, then re-check what was saved.
      if (Object.prototype.toString.call(saved.upsells) === '[object Array]') {
        root.querySelectorAll('.personalizer__upsell-input').forEach(function (input) { input.checked = false; });
        saved.upsells.forEach(function (variantId) {
          var idSafe = String(variantId).replace(/[^0-9]/g, '');
          var input = root.querySelector('.personalizer__upsell-input[value="' + idSafe + '"]');
          if (input) input.checked = true;
        });
        // The name charm's checkbox value follows its picked colour, so any of
        // its colour variants in the saved list re-ticks the row.
        root.querySelectorAll('.personalizer__upsell-input[data-name-charm]').forEach(function (input) {
          var ids = [];
          try {
            var vs = JSON.parse(input.getAttribute('data-variants') || '{}');
            Object.keys(vs).forEach(function (k) { ids.push(String(vs[k].id)); });
          } catch (e) { /* malformed map — the row simply is not restored */ }
          var hit = saved.upsells.some(function (id) { return ids.indexOf(String(id).replace(/[^0-9]/g, '')) !== -1; });
          if (hit) input.checked = true;
        });
      }
      // A restored count was chosen once already — don't make them pick twice.
      if (state.besties.length) state.countChosen = saved.countChosen !== false;
      // Applied after the flow is built, once activeSteps() is meaningful.
      if (typeof saved.currentStep === 'string') savedStep = saved.currentStep;
      state.note = typeof saved.note === 'string' ? saved.note : '';
      if (typeof saved.orderName === 'string') state.orderName = saved.orderName.slice(0, 60);
      if (notesEl) notesEl.value = state.note;
      if (typeKeys.indexOf(saved.orderType) !== -1) state.orderType = saved.orderType;
      if (typeof saved.axis === 'string') state.axis = saved.axis;
      state.sameSubject = typeof saved.sameSubject === 'boolean' ? saved.sameSubject : null;
      state.twin = saved.twin === true;
      // upsellNotes: {handle: string} — free text, capped, never trusted.
      if (saved.upsellNotes && typeof saved.upsellNotes === 'object' && !Array.isArray(saved.upsellNotes)) {
        Object.keys(saved.upsellNotes).forEach(function (h) {
          if (typeof saved.upsellNotes[h] === 'string') state.upsellNotes[h] = saved.upsellNotes[h].slice(0, 120);
        });
      }
      // upsellNameCharm: {items: [{colour, name}]} — colours must be ones the
      // config offers, names capped, at most one charm per pet; never trusted.
      if (saved.upsellNameCharm && typeof saved.upsellNameCharm === 'object') {
        var ncCfg = config.nameCharmUpsell || {};
        var ncNames = (ncCfg.colours || []).map(function (c) { return c.name; });
        var rawItems = Array.isArray(saved.upsellNameCharm.items) ? saved.upsellNameCharm.items
          : (typeof saved.upsellNameCharm.colour === 'string' || typeof saved.upsellNameCharm.name === 'string') ? [saved.upsellNameCharm] : [];
        state.upsellNameCharm = { items: rawItems.slice(0, Math.max(1, state.besties.length)).map(function (it) {
          it = it || {};
          return {
            colour: ncNames.indexOf(it.colour) !== -1 ? it.colour : '',
            name: typeof it.name === 'string' ? it.name.slice(0, ncCfg.maxLetters || 8) : ''
          };
        }) };
      }
      // upsellPhotos: {handle: [idx]} — indexes into the restored photos; bounds
      // are re-checked at render/validate time, so only the shape is trusted.
      if (saved.upsellPhotos && typeof saved.upsellPhotos === 'object' && !Array.isArray(saved.upsellPhotos)) {
        Object.keys(saved.upsellPhotos).forEach(function (h) {
          var arr = saved.upsellPhotos[h];
          if (Array.isArray(arr)) state.upsellPhotos[h] = arr.filter(function (i) { return typeof i === 'number' && i >= 0 && i < 12; });
        });
      }
      // upsellPets: {handle: [0..2]} — anything else is dropped, not trusted.
      if (saved.upsellPets && typeof saved.upsellPets === 'object' && !Array.isArray(saved.upsellPets)) {
        Object.keys(saved.upsellPets).forEach(function (h) {
          var arr = saved.upsellPets[h];
          if (Array.isArray(arr)) {
            state.upsellPets[h] = arr.filter(function (i) { return typeof i === 'number' && i >= 0 && i < maxUnits; });
          }
        });
      }
    }
  } catch (err) {
    // Corrupted saved state must not abort init — drop the key, start fresh.
    try { sessionStorage.removeItem(storageKey); } catch (ignored) { /* storage blocked */ }
    state.besties = [];
    state.note = '';
  }

  // Fresh visit (or empty restore): the approved default is 2 besties, each a
  // Full Set. oneBag products default to 1 unit; count-mode products (nursery
  // mobiles) default to config.defaultUnits (what customers buy most).
  if (!state.besties.length) {
    var freshCount = 2;
    if (config.bagMode === 'oneBag') freshCount = 1;
    if (config.bagMode === 'count') freshCount = Math.min(parseInt(config.defaultUnits, 10) || 2, maxUnits);
    state.besties = [];
    for (var fc = 0; fc < freshCount; fc++) state.besties.push({ type: defaultType, color: null, petName: '' });
    // Bag products present that first unit as a starting price, not a pick.
    state.countChosen = config.bagMode !== 'oneBag';
  }
  enforceOneBagTypes();

  /* Land back where they left off. Only as far as the flow still allows: a
     saved step whose earlier steps no longer validate (a restore that dropped
     a stale colour, say) would strand them on a page they cannot leave, so the
     furthest VALID step wins instead. */
  if (savedStep) {
    var order = activeSteps();
    var wanted = order.indexOf(savedStep);
    if (wanted > 0) {
      var reachable = 0;
      while (reachable < wanted && stepValid(order[reachable])) reachable++;
      currentStep = order[reachable];
      for (var vs = 0; vs < reachable; vs++) visitedSteps[order[vs]] = true;
    }
  }

  syncUpsellsFromDom(); // pre-checked recommended upsell counts from first paint
  syncUpsellRowClasses(); // initial row classes (Liquid-checked default or restore)

  // Same-photo carry-over: a fresh session (no photos restored) picks up the
  // photos the customer brought from their previous order (post-purchase email
  // → landing page → localStorage, same-photo-prefill.js). Every URL passes the
  // SAME validation rule as any session-restored URL before it is trusted.
  if (!savedPhotos.length && window.DollfySamePhoto) {
    var carriedOver = window.DollfySamePhoto.read();
    if (carriedOver) {
      savedPhotos = carriedOver.photos.filter(function (p) {
        return p && p.url && window.PersonalizerUpload.isValidUploadedUrl(p.url);
      });
    }
  }

  /* Photo groups: one for the whole order (every product) plus, on products
     that ask "same person?", one more per further doll — used only while the
     dolls are different people, so each person gets their own upload row.
     The extra rows are cloned from the authored skeleton before the first
     group is wired, so no listener or restored tile is duplicated. A facade
     with the single-group API (getPhotos / isValid) stands in for the group
     everywhere else: photos come back in doll order. */
  var photoGroups = [];
  function photoSplit() {
    return !!(config.sameSubject && state.sameSubject === false && state.besties.length >= 2);
  }
  function activePhotoGroups() {
    return photoSplit() ? photoGroups.slice(0, state.besties.length) : photoGroups.slice(0, 1);
  }
  function buildPhotoUnit(skeleton, idx) {
    var el = document.createElement('div');
    el.className = 'personalizer__photos-unit';
    el.setAttribute('data-photo-unit', String(idx));
    el.hidden = true;
    var lb = document.createElement('div');
    lb.className = 'personalizer__bl personalizer__photos-unit-lb';
    lb.setAttribute('data-photo-unit-label', '');
    el.appendChild(lb);
    ['.personalizer__file-drop', '[data-photo-notice]', '[data-photo-previews]', '[data-photo-progress]', '[data-photo-error]'].forEach(function (sel) {
      var src = skeleton.querySelector(sel);
      if (!src) return;
      var c = src.cloneNode(true);
      // the thumbnail list stays visible (the uploader never unhides it);
      // notice / progress / error start hidden like the authored ones
      if (sel === '[data-photo-previews]') c.innerHTML = '';
      else if (sel !== '.personalizer__file-drop') c.hidden = true;
      var inp = c.querySelector('[data-photo-input]');
      if (inp) {
        inp.value = '';
        inp.setAttribute('aria-label', 'Add photos for ' + (config.unitLabel || 'Doll').toLowerCase() + ' ' + (idx + 1));
      }
      el.appendChild(c);
    });
    return el;
  }
  // restored photos per doll: the saved per-doll counts split the RAW list,
  // then each slice drops invalid URLs — so a dropped URL never shifts the
  // next doll's photos onto the wrong doll
  function splitSavedPhotos(count) {
    var ok = function (p) { return p && p.url && window.PersonalizerUpload.isValidUploadedUrl(p.url); };
    if (!savedPhotoUnits) return [savedPhotos];
    var out = [], at = 0;
    for (var i = 0; i < count; i++) {
      var c = savedPhotoUnits[i] || 0;
      out[i] = savedPhotosRaw.slice(at, at + c).filter(ok);
      at += c;
    }
    if (at < savedPhotosRaw.length) out[0] = (out[0] || []).concat(savedPhotosRaw.slice(at).filter(ok));
    return out;
  }
  var photoUnitCount = (config.sameSubject && config.bagMode === 'count') ? maxUnits : 1;
  var photosRoot = root.querySelector('[data-photo-group]');
  var unitHost = photosRoot ? photosRoot.querySelector('[data-photo-units]') : null;
  var savedByUnit = splitSavedPhotos(photoUnitCount);
  var groupOpts = function (unitIdx) {
    return {
      uploadEndpoint: config.uploadEndpoint,
      // Live callback: every order gets at least maxPhotos (10 — customers
      // send several angles per pet); large multi-bestie orders keep their
      // per-bestie allowance when that works out higher. Split rows share
      // the order's allowance between the dolls.
      getMaxPhotos: function () {
        var perBestie = config.maxPhotosPerBestie || 2;
        var n = Math.max(state.besties.length, 1);
        if (photoSplit()) return Math.max(perBestie, Math.floor((config.maxPhotos || 10) / n));
        return Math.max(config.maxPhotos || 10, perBestie * n);
      },
      maxFileMb: config.maxFileMb,
      requirePhotos: config.requirePhotos,
      restored: savedByUnit[unitIdx] || [],
      onChange: ctx.onStateChange
    };
  };
  var unitEls = [];
  for (var u = 1; u < photoUnitCount && unitHost; u++) {
    var unitEl = buildPhotoUnit(photosRoot, u);
    unitHost.appendChild(unitEl);
    unitEls.push(unitEl);
  }
  photoGroups.push(window.PersonalizerUpload.initPhotoGroup(photosRoot, groupOpts(0)));
  unitEls.forEach(function (el, i) {
    photoGroups.push(window.PersonalizerUpload.initPhotoGroup(el, groupOpts(i + 1)));
  });
  photoGroup = photoGroups[0] ? {
    getPhotos: function () {
      var all = [];
      activePhotoGroups().forEach(function (g) { if (g) all = all.concat(g.getPhotos()); });
      return all;
    },
    isValid: function () {
      return activePhotoGroups().every(function (g) { return !g || g.isValid(); });
    },
    // photos per doll in doll order — null unless the dolls are different people
    getPhotosByUnit: function () {
      return photoSplit() ? activePhotoGroups().map(function (g) { return g ? g.getPhotos() : []; }) : null;
    }
  } : null;

  // default axis = countAxis.default when it names an orderable value (prefix
  // match, so "8 INCHES" still hits "8 INCHES (Best Gift)"), else the first
  // value that can actually be ordered
  if (config.countAxis && window.PersonalizerCart.axisValues) {
    var axes = window.PersonalizerCart.axisValues(config);
    var savedOk = axes.some(function (a) { return a.name === state.axis && !a.soldOut; });
    if (!savedOk) {
      var live = axes.filter(function (a) { return !a.soldOut; });
      var wanted = String(config.countAxis.default || '').toLowerCase();
      var preferred = wanted
        ? live.filter(function (a) { return a.name.toLowerCase().indexOf(wanted) === 0; })[0]
        : null;
      var first = preferred || live[0];
      state.axis = first ? first.name : null;
    }
  }
  // The axis mount is authored inside the count panel (where every other
  // count-mode product shows it). Products that give the axis its own page
  // adopt the same node into that page instead of duplicating the markup —
  // moving a node keeps everything renderAxis wired onto it.
  if (axisOwnStep) {
    var sizePanel = root.querySelector('[data-personalizer-size-panel]');
    var axisMount = root.querySelector('[data-personalizer-axis]');
    if (sizePanel && axisMount) sizePanel.appendChild(axisMount);
  }
  window.PersonalizerRender.renderOrderType(ctx);
  window.PersonalizerRender.renderAxis(ctx);
  window.PersonalizerRender.renderCounts(ctx);
  window.PersonalizerRender.renderTypeRows(ctx);
  window.PersonalizerRender.renderColorRows(ctx);
  window.PersonalizerRender.renderNames(ctx);
  refreshUI();
})();
